<template>
	<header class="head">
		<div class="head-inner">
			<div class="logo" id="logoMain" @click="checkActive(0)">
				Open-<span>ADC</span>
			</div>

			<nav class="nav">
				<div
					:class="['nav-item', activeIndex === index ? 'nav-item-active' : '']"
					v-for="(item, index) in list"
					:key="item.id"
					@click="checkActive(index)"
				>
					<span :class="['nav-text', activeIndex === index ? 'isActive' : '']">
						{{ $t(`message.${item.name}`) }}
					</span>
				</div>
			</nav>
		</div>
	</header>
</template>

<script>
export default {
	name: 'PageHeader',
	data() {
		return {
			activeIndex: 0,
			list: [
				{
					id: 0,
					url: '',
					name: 'Home'
				},
				{
					id: 1,
					url: '',
					name: 'Search'
				},
				{
					id: 2,
					url: '',
					name: 'About'
				}
			]
		}
	},
	methods: {
		checkActive(index) {
			this.activeIndex = index
			if (index == 0) {
				this.url = 'index'
			} else if (index == 1) {
				this.url = 'PeriodicTable'
			} else if (index == 2) {
				this.url = 'CorporateValue'
			} else {
				return false
			}
			this.$router.push({
				name: this.url
			})
		}
	},
	created() {
		if (this.$route.name == 'PeriodicTable' || this.$route.name == 'StudentFeedback') {
			this.activeIndex = 1
		} else if (this.$route.name == '') {
			this.activeIndex = 0
		} else if (this.$route.name == 'CorporateValue') {
			this.activeIndex = 2
		}
	}
}
</script>

<style scoped>
.head {
	height: 72px;
	background: #fcfdff;
	border-bottom: 1px solid #dbe4ee;
	box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
	font-family: 'Open Sans Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	position: sticky;
	top: 0;
	z-index: 1000;
}

.head-inner {
	height: 100%;
	padding: 0 60px 0 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
}

.logo {
	font-size: 28px;
	font-weight: 700;
	letter-spacing: -0.02em;
	line-height: 1;
	color: #0f274d;
	cursor: pointer;
	margin-left: 100px;
	transition: color 0.2s ease;
}

.logo span {
	color: #1f4fa3;
}

.logo:hover {
	color: #1f4fa3;
}

.nav {
	display: flex;
	align-items: center;
	gap: 28px;
	margin-right: 120px;
}

.nav-item {
	position: relative;
	cursor: pointer;
}

.nav-text {
	font-size: 15px;
	font-weight: 600;
	line-height: 1;
	color: #334155;
	transition: color 0.2s ease;
	padding: 6px 0;
	display: inline-block;
}

.nav-text:hover {
	color: #1f4fa3;
}

.isActive {
	color: #1f4fa3;
}

.nav-item::after {
	content: '';
	position: absolute;
	left: 0;
	bottom: -18px;
	width: 100%;
	height: 2px;
	background: transparent;
	transition: background 0.2s ease;
}

.nav-item-active::after {
	background: #1f4fa3;
}

@media (max-width: 960px) {
	.head {
		height: 64px;
	}

	.head-inner {
		padding: 0 14px;
	}

	.logo {
		font-size: 22px;
		margin-left: 0;
	}

	.nav {
		gap: 18px;
		margin-right: 0;
	}

	.nav-text {
		font-size: 14px;
	}

	.nav-item::after {
		bottom: -15px;
	}
}
</style>